import type { RiskLevel } from "@/lib/api";

const STYLES: Record<RiskLevel, { label: string; className: string }> = {
  LOW: {
    label: "Low risk",
    className: "bg-curate-mist text-curate-ink border-curate-slate/20",
  },
  MEDIUM: {
    label: "Medium risk",
    className: "bg-curate-warn/10 text-curate-warn border-curate-warn/30",
  },
  HIGH: {
    label: "High risk",
    className: "bg-curate-danger/10 text-curate-danger border-curate-danger/30",
  },
};

export function RiskBadge({ level }: { level: RiskLevel }) {
  const s = STYLES[level];
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-2xs font-medium ${s.className}`}
    >
      {s.label}
    </span>
  );
}
